import { InvNormLabParams } from './inv-norm-lab.component';

export const INV_NORM_LAB_DEFAULT: InvNormLabParams = {
  initialMu: 100,
  initialSigma: 26,
  initialP: 0.86,
};

export const INV_NORM_LAB_STANDARD_NORMAL: InvNormLabParams = {
  initialMu: 0,
  initialSigma: 1,
  initialP: 0.95,
};

export const INV_NORM_LAB_SMALL_P: InvNormLabParams = {
  initialMu: 50,
  initialSigma: 10,
  initialP: 0.1,
};

export const INV_NORM_LAB_LARGE_SPREAD: InvNormLabParams = {
  initialMu: 0,
  initialSigma: 40,
  initialP: 0.5,
};

export const INV_NORM_LAB_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: INV_NORM_LAB_DEFAULT },
  'standard-normal': { params: INV_NORM_LAB_STANDARD_NORMAL },
  'small-p': { params: INV_NORM_LAB_SMALL_P },
  'large-spread': { params: INV_NORM_LAB_LARGE_SPREAD },
};
